
// @ts-nocheck
declare var gGDPR_logoURL: string;
declare var gGDPR_privacyPolicyURL: string;
declare var gGDPR_termsOfServiceURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import { setCookie } from "@/util";

@Component({
  props: {
    cmpApi: Object,
  },
})

export default class LayerSimpleAgreeModal extends Vue {

  logo_URL = typeof gGDPR_logoURL === "string" ? gGDPR_logoURL : "";
  privacyURL = "";
  termsURL = "";

  mounted(): void {
    this.privacyURL = typeof gGDPR_privacyPolicyURL === "string" ? gGDPR_privacyPolicyURL : "";

    const hasTerms = typeof gGDPR_termsOfServiceURL === "string" && gGDPR_termsOfServiceURL !== "";
    this.termsURL = hasTerms ? gGDPR_termsOfServiceURL : this.privacyURL;
  }

  @Emit('changeViewEvent')
  agreeClick(): string {
    setCookie( "amp-gpp-agreed", "1", 365 );
    return 'close';
  }

}
